import type { InsightStatus } from '../models/insight.types'

import type { ApiErrorKind } from '@/shared/http'

/** Content-free failure metadata for a best-effort status write. */
export interface InsightStatusWriteFailure {
  attemptedStatus: InsightStatus
  kind: ApiErrorKind
  status: number | null
  code: string | null
}

export type InsightStatusWriteFailureReporter = (failure: InsightStatusWriteFailure) => void

let reporter: InsightStatusWriteFailureReporter = () => {}

export function registerInsightStatusWriteFailureReporter(
  next: InsightStatusWriteFailureReporter,
): () => void {
  reporter = next
  return () => {
    if (reporter === next) reporter = () => {}
  }
}

export function reportInsightStatusWriteFailure(failure: InsightStatusWriteFailure): void {
  try {
    reporter(failure)
  } catch {
    // Observability is best-effort and must not perturb the detail interaction.
  }
}
